import React from 'react';
import { Modal, Input, Form, message, Checkbox, Button, Switch } from 'antd';
import { DOLARES_AMERICANOS, SOLES } from "../../../../common/types/monedaType";

class FormModal extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
        }
    }


    handleOk = () => {
        var row = this.props.formValues;
        var idMoneda = this.props.moneda;
        this.props.form.validateFields((errors, values) => {
            if (!errors) {
                var precioUnitarioInclyIGV = this.props.precioUnitarioIncluyeIGV;
                var valor = 0;

                if (!precioUnitarioInclyIGV && idMoneda === SOLES) {
                    valor = parseFloat(values.valorUnitarioSoles);
                    if (valor <= row.precioPromedioSoles) {
                        message.warning("El monto ingresado debe ser mayor a " + row.precioPromedioSoles);
                        return;
                    }

                } else if (precioUnitarioInclyIGV && idMoneda === SOLES) {
                    valor = parseFloat(values.precioUnitarioSoles);
                    if (valor <= row.valorPromedioSoles) {
                        message.warning("El monto ingresado debe ser mayor a " + row.valorPromedioSoles);
                        return;
                    }
                } else if (
                    !precioUnitarioInclyIGV &&
                    idMoneda === DOLARES_AMERICANOS
                ) {
                    valor = parseFloat(values.valorUnitarioDolares);
                    if (valor <= row.precioPromedioDolares) {
                        message.warning("El monto ingresado debe ser mayor a " + row.precioPromedioDolares);
                        return;
                    }
                } else if (
                    precioUnitarioInclyIGV &&
                    idMoneda === DOLARES_AMERICANOS
                ) {
                    valor = parseFloat(values.precioUnitarioDolares);
                    if (valor <= row.valorPromedioDolares) {
                        message.warning("El monto ingresado debe ser mayor a " + row.valorPromedioDolares);
                        return;
                    }
                }

                const form = {
                    id: row.id,
                    listaPrecioId: row.id,
                    idMoneda: this.props.moneda,
                    valor: valor,
                    idProducto: row.idProducto,
                };
                this.props.onSaveExpand(form, this.props.form);

                setTimeout(() => {
                    this.props.onClose();
                }, 3000);
            }
        });
    };

    handleCancel = () => {
        this.props.onClose();
        this.props.form.resetFields();
    }

    render() {
        const { getFieldDecorator, getFieldValue } = this.props.form;

        return (
            <Modal
                title={"Modificar Lista precio Conversion"}
                visible={this.props.visible}
                cancelText={"Cancelar"}
                okText={"Guardar"}
                onCancel={this.handleCancel}
                onOk={this.handleOk}
                style={{ top: 30 }}
            >
                <Form>
                    <div className="row">
                        <div className="col-md-12 form-group">
                            <Form.Item label="Nombre">
                                {getFieldDecorator('nombreProducto', {
                                    initialValue: this.props.formValues.nombreProducto,
                                })(
                                    <Input
                                        placeholder="Ingresar Nombre"
                                        autoComplete="off"
                                    />
                                )}
                            </Form.Item>
                        </div>
                        <div className="col-md-12 form-group">
                            <Form.Item label="Moneda">
                                {getFieldDecorator('nombre', {
                                    initialValue: this.props.moneda == 1 ? 'SOLES' : 'DOLARES',
                                })(
                                    <Input
                                        placeholder="Ingresar Nombre"
                                        autoComplete="off"
                                    />
                                )}
                            </Form.Item>
                        </div>
                        {
                            this.props.moneda == 1 ?
                                <>
                                    <div className="col-md-12 form-group">
                                        <Form.Item label="Valor Unitario Soles">
                                            {getFieldDecorator('valorUnitarioSoles', {
                                                initialValue: this.props.formValues.valorUnitarioSoles,
                                                rules: [{
                                                    required: this.props.precioUnitarioIncluyeIGV ? false : true,
                                                    message: 'Campo obligatorio.',

                                                }]
                                            })(
                                                <Input
                                                    placeholder="Ingresar Valor"
                                                    autoComplete="off"
                                                    disabled={this.props.precioUnitarioIncluyeIGV ? true : false}


                                                />
                                            )}
                                        </Form.Item>
                                    </div>
                                    <div className="col-md-12 form-group">
                                        <Form.Item label="Precio Unitario Soles">
                                            {getFieldDecorator('precioUnitarioSoles', {
                                                initialValue: this.props.formValues.precioUnitarioSoles,
                                                rules: [{
                                                    required: this.props.precioUnitarioIncluyeIGV ? true : false,
                                                    message: 'Campo obligatorio.',
                                                }]
                                            })(
                                                <Input
                                                    placeholder="Ingresar Precio"
                                                    autoComplete="off"
                                                    disabled={this.props.precioUnitarioIncluyeIGV ? false : true}

                                                />
                                            )}
                                        </Form.Item>
                                    </div>
                                </> :
                                <>
                                    <div className="col-md-12 form-group">
                                        <Form.Item label="Valor Unitario Dolares">
                                            {getFieldDecorator('valorUnitarioDolares', {
                                                initialValue: this.props.formValues.valorUnitarioDolares,
                                                rules: [{
                                                    required: this.props.precioUnitarioIncluyeIGV ? false : true,
                                                    message: 'Campo obligatorio.',
                                                }]
                                            })(
                                                <Input
                                                    placeholder="Ingresar Valor"
                                                    autoComplete="off"
                                                    disabled={this.props.precioUnitarioIncluyeIGV ? true : false}

                                                />
                                            )}
                                        </Form.Item>
                                    </div>
                                    <div className="col-md-12 form-group">
                                        <Form.Item label="Precio Unitario Dolares">
                                            {getFieldDecorator('precioUnitarioDolares', {
                                                initialValue: this.props.formValues.precioUnitarioDolares,
                                                rules: [{
                                                    required: this.props.precioUnitarioIncluyeIGV ? false : true,
                                                    message: 'Campo obligatorio.',
                                                }]
                                            })(
                                                <Input
                                                    placeholder="Ingresar Precio"
                                                    autoComplete="off"
                                                    disabled={this.props.precioUnitarioIncluyeIGV ? false : true}

                                                />
                                            )}
                                        </Form.Item>
                                    </div>
                                </>
                        }


                    </div>
                </Form>
            </Modal>
        );
    }
}
export default Form.create()(FormModal)